import { forwardRef, type InputHTMLAttributes } from 'react';
import { cn } from '../utils/cn';

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  hint?: string;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(function Input(
  { label, error, hint, className, id, ...rest },
  ref
) {
  const inputId = id ?? `in-${Math.random().toString(36).slice(2, 9)}`;
  return (
    <div className="flex w-full flex-col gap-1">
      {label && (
        <label htmlFor={inputId} className="text-xs font-medium text-[var(--color-text-secondary)]">
          {label}
        </label>
      )}
      <input
        id={inputId}
        ref={ref}
        className={cn(
          'h-10 w-full rounded-md border px-3 text-sm outline-none transition-colors',
          'border-[var(--color-border)] bg-[var(--color-bg-card)] text-[var(--color-text-primary)]',
          'placeholder:text-[var(--color-text-muted)] focus:border-[var(--color-primary)]',
          error && 'border-[var(--color-danger)]',
          className
        )}
        {...rest}
      />
      {error ? (
        <span className="text-xs text-[var(--color-danger)]">{error}</span>
      ) : hint ? (
        <span className="text-xs text-[var(--color-text-muted)]">{hint}</span>
      ) : null}
    </div>
  );
});

export default Input;
